  import { useDispatch, useSelector } from "react-redux";
  import {
    closeModal,
    openModal,
  } from "../../features/shareModal/ShareModalSlice";

  const useShareTopic = () => {
    const { isOpen, copied } = useSelector(
      (state) => state.shareModal,
    );
    const dispatch = useDispatch();

    return {
      isOpen,
      copied,
      openModal: () => dispatch(openModal()),
      closeModal: () => dispatch(closeModal()),
    };
  };

  export default useShareTopic;
